module.exports = __webpack_public_path__ + "static/media/dgsf-siegel-empfohlene-einrichtungen.a3e5a8b2.jpg";